import React from 'react';
import {Route} from 'react-router-dom';
import AsyncSdkPrivacy from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default (
    <Route
        key="/business/SDK/privacy"
        element={
            <DefaultBusinessLayout
                breadcrumb={[
                    {
                        position: 1,
                        name: 'Home',
                        item: '/',
                    },
                    {
                        position: 2,
                        name: 'Business',
                        item: '/business',
                    },
                    {
                        position: 3,
                        name: 'SDK Privacy',
                        item: '/business/SDK/privacy',
                    }
                ]}
            />
        }
    >
        <Route path="business/SDK/privacy" element={<AsyncSdkPrivacy />} />
    </Route>
);
